import { type Quote } from '../../../../modules/quotes'
import { type QuotesViewHandler } from '../quotesView.types'

const sort = (quotes: Quote[]) => {
  return quotes
}

const viewHandler: QuotesViewHandler = {
  sort,
}

export default viewHandler
